import React from 'react';
// eslint-disable-next-line no-unused-vars -- used in JSX below
import surgeIcon from '../Images/SURGE_ICON.svg';
import './Card.css';

const SUIT_SYMBOL = { s: '♠', h: '♥', d: '♦', c: '♣', joker: '🃏' };

const PIP_CYCLE = ['♠', '♥', '♦', '♣'];
const PIP_COLS = 6;
const PIP_ROWS = 9;
const BACK_PIPS = [];
for (let r = 0; r < PIP_ROWS; r++) {
  const offset = r % 2 === 1 ? 6 : 0;
  for (let c = 0; c < PIP_COLS; c++) {
    BACK_PIPS.push({
      x: 3 + offset + c * 12,
      y: 7 + r * 11,
      pip: PIP_CYCLE[(r + c) % 4],
    });
  }
}

function rankLabel(rank) {
  if (rank === 'joker') return 'JOKER';
  if (rank === 1) return 'A';
  if (rank === 11) return 'J';
  if (rank === 12) return 'Q';
  if (rank === 13) return 'K';
  return String(rank);
}

export default function Card({
  card,
  faceUp = true,
  selected = false,
  pressed = false,
  dragging = false,
  onClick,
  disabled,
  plainBack = false,
}) {
  if (!card) return null;
  const isJoker = card.isJoker;
  const suit = card.suit;
  const rank = isJoker ? 'joker' : card.rank;
  const suitSymbol = SUIT_SYMBOL[suit] || SUIT_SYMBOL.joker;
  const rankStr = rankLabel(rank);
  const isRed = suit === 'h' || suit === 'd';

  return (
    <button
      type="button"
      className={`card ${faceUp ? 'card--face-up' : 'card--face-down'} ${isRed ? 'card--red' : ''} ${selected ? 'card--selected' : ''} ${pressed ? 'card--pressed' : ''} ${dragging ? 'card--dragging' : ''} ${disabled ? 'card--disabled' : ''}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={faceUp ? (isJoker ? 'Joker' : `${rankStr} ${suitSymbol}`) : 'Face down card'}
    >
      {faceUp ? (
        <>
          <span className="card__corner card__corner--top">
            <span className="card__rank">{rankStr}</span>
            {!isJoker && <span className="card__suit">{suitSymbol}</span>}
          </span>
          <span className="card__center">
            {isJoker ? (
              <span className="card__joker">JOKER</span>
            ) : (
              <>
                <span className="card__center-rank">{rankStr}</span>
                <span className="card__center-suit">{suitSymbol}</span>
              </>
            )}
          </span>
          <span className="card__corner card__corner--bottom">
            <span className="card__rank">{rankStr}</span>
            {!isJoker && <span className="card__suit">{suitSymbol}</span>}
          </span>
        </>
      ) : (
        <span className="card__back" aria-hidden>
          {!plainBack && (
            <>
              <svg className="card__back-deco" viewBox="0 0 72 100">
                {BACK_PIPS.map((p, i) => (
                  <text key={i} x={p.x} y={p.y}>{p.pip}</text>
                ))}
              </svg>
              <img src={surgeIcon} alt="" className="card__back-logo" />
            </>
          )}
        </span>
      )}
    </button>
  );
}
